module.exports = __webpack_public_path__ + "static/media/boulevard.23262ee7.jpg";